module.exports = __webpack_public_path__ + "media/images/elizabethtown-ky-realtors-2x-bdc65d35.jpg";